<template>
<div class="chapter">
<div class="inner_page">
<div class="fmtitle"><span><a id="pageviii"></a><a id="pageix"></a><b><a href="#/contents#rmap" id="map"><span style="color:#000000;">Maps</span></a></b></span></div>
<div class="image2"><span><img alt="image" src="images/common.png"/></span></div>
<div class="toc3"><span><a href="#/ch02#map1" id="rmap1">European Intrusions in North America</a></span></div>
<div class="toc3"><span><span href="#/ch03#map2" id="rmap2" title="Link target outside of Sample">Indigenous Mexico</span></span></div>
<div class="toc3"><span><span href="#/ch03#map3" id="rmap3" title="Link target outside of Sample">Mexican States Mentioned in Chapter 3</span></span></div>
<div class="toc3"><span><span href="#/ch04#map4" id="rmap4" title="Link target outside of Sample">Some Indigenous Groups in the United States</span></span></div>
<div class="toc3"><span><span href="#/ch05#map5" id="rmap5" title="Link target outside of Sample">Indian Territory as Defined by the Royal Proclamation of 1763</span></span></div>
<div class="toc3"><span><span href="#/ch05#map6" id="rmap6" title="Link target outside of Sample">Canada</span></span></div>
<div class="toc3"><span><span href="#/ch06#map7" id="rmap7" title="Link target outside of Sample">Australia with Aboriginal Reserves</span></span></div>
<div class="toc3"><span><span href="#/ch07#map8" id="rmap8" title="Link target outside of Sample">Indonesia</span></span></div>
<div class="toc3"><span><span href="#/ch07#map9" id="rmap9" title="Link target outside of Sample">Namibia, Botswana, South Africa, Tanzania, and Kenya</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?35652396